module.exports = __webpack_public_path__ + "a4f1bbf05e03898cfb70617b61bd8894.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/section6/imgs/4.jpg
// module id = 397
// module chunks = 0